/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-discount-groups",
	props:{
		companyId: {
			default: null
		}
	},
	data() {
		return {
			discountGroups: [],
			customerDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Discount Amount",
					field: "discountAmount"
				},
				{
					text: "Is Active?",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			customer: null,
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			actionKeys:{
				viewProduct: "viewProduct"
			},
			customerDiscountGroupLinkedProductsModal:{
				showModal: false,
				modalId: "customerDiscountGroupLinkedProductsModal",
				heading: "Linked Products",
				customerDiscountGroupId: null
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			// get customer
			this.customer = {
				customerId: 1,
				customerCode: "ABC2323",
				name: "ABC Company",
				erpCustomerCode: "DWDE23232",
				vatNumber: "121221211",
				emailAddress: "test@test.com",
				phoneNumber: "0325151122",
				isActive: true,
				dateCreated: "10/05/2023"
			};
		},
		getCustomerDiscountGroups() {
			this.discountGroups = [
				{
					discountGroupId: 1,
					customerId: 1,
					name: "Pump Less Than 2 Cents",
					discountAmount: "R0.02",
					isActive: true
				},
				{
					discountGroupId: 2,
					customerId: 1,
					name: "Pump Less Than 4 Cents",
					discountAmount: "R0.04",
					isActive: true
				}
			];
			for(var i = 0; i < this.discountGroups.length; i++){
				this.discountGroups[i].actions = [
					{
						name: "View Product",
						key: this.actionKeys.viewProduct
					}
				];
			}
			this.discountGroups = dataTableHelper.castFieldValues(this.discountGroups);
			this.filterStateChanged = false;
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			//TODO: filter customer results
			this.getCustomerDiscountGroups();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);	
		},
		onDiscountGroupActionClicked(actionKeyAndData) {
			if(actionKeyAndData.action === this.actionKeys.viewProduct){
				this.customerDiscountGroupLinkedProductsModal.showModal = true;
				this.customerDiscountGroupLinkedProductsModal.customerDiscountGroupId = actionKeyAndData.data.discountGroupId;
				this.customerDiscountGroupLinkedProductsModal.heading = this.customerDiscountGroupLinkedProductsModal.heading + " - " + this.customer.name;
			}
		},
		onCustomerDiscountGroupProductModalOkClick() {
			this.customerDiscountGroupLinkedProductsModal.showModal = false;
			this.customerDiscountGroupLinkedProductsModal.heading = "Linked Products";
		},
		setBreadcrumbs() {
			var pageTitle = "Customer Discount Groups";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getCustomerDiscountGroups();
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};